import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const menuStyles: SxProps<Theme> = (theme) => ({
	'& .MuiPaper-root': {
		marginTop: { xs: 0, sm: '10px' },
		borderRadius: { xs: '16px 16px 0 0', sm: '8px' },
		backgroundColor: Colors['101010'],
		border: `1px solid ${Colors['2A2A2A']}`,
	},

	'& .MuiList-root': {
		padding: 0,
	},

	[theme.breakpoints.down('sm')]: {
		'& .MuiBackdrop-root': {
			backdropFilter: 'blur(10px)',
		},

		'& .MuiPaper-root': {
			maxWidth: '100%',
			width: '100%',
			bottom: 0,
		},
	},
});
